import { render, staticRenderFns } from "./OrgaDataMst.vue?vue&type=template&id=63382538&scoped=true"
import script from "./OrgaDataMst.vue?vue&type=script&lang=js"
export * from "./OrgaDataMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63382538",
  null
  
)

export default component.exports